import service from "../utils/request";

interface UserInfoParam {
  userID: string;
  userName: string;
}
export function apiGetUserInfo(param: UserInfoParam) {
  return service({
    url: "/api/chat/web/role/all",
    method: "get",
    data: param,
  });
}
interface CharActers {
  message?: string;
}
export function apiCharActers(param: CharActers) {
  // return service.get('/api/data', { responseType: 'text/event-stream' })
  return service({
    method: "get",
    url: "/api/chat/characters",
    data: param,
  });
}

interface RoleGroupList {
  data?: string;
}
export function roleGroupList(param: RoleGroupList) {
  // return service.get('/api/data', { responseType: 'text/event-stream' })
  return service({
    method: "get",
    url: "/api/chat/web/role/group/list",
    params: param,
  });
}
export function authLogin() {
  return service({
    method: "post",
    url: "/api/auth/login",
  });
}

export function wxLogin() {
  return service({
    method: "get",
    url: "/api/wx/login/getWechatQtCode",
  });
}
interface WxLogin {
  key?: string;
}

// export function getWxLogin(param: WxLogin) {
//   return service({
//     method: "get",
//     url: "/api/wx/login/login/check/test",
//     params: param,
//   });
// }
interface RoleList {
  groupId?: string | number;
  pageNo?: number;
  pageSize?: number;
  key?: string;
  actionType?: string;
  type?: string;
}
export function roleList(param: RoleList) {
  return service({
    method: "get",
    url: "/api/chat/web/role/list",
    params: param,
  });
}

interface ChatRequest {
  prompt?: string;
  appCode?: string;
}
export function completion(data: ChatRequest) {
  return service({
    method: "post",
    url: "/api/chat/web/completion",
    data: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
interface GetWeChatPublicAccountImageCheck {
  share?: string;
}
export function getWeChatPublicAccountImage(
  param?: GetWeChatPublicAccountImageCheck
) {
  return service({
    method: "get",
    url: "/api/wx/public/login/getWeChatPublicAccountImageBase64",
    params: param,
  });
}

export function loginCheckState(param: WxLogin) {
  return service({
    method: "get",
    url: "/api/wx/public/login/check/state",
    params: param,
  });
}

export function bindCheckState(param: WxLogin) {
  return service({
    method: "get",
    url: "/api/wx/public/login/check/bind/state",
    params: param,
  });
}
interface RoleAddCheck {
  description?: string;
  groupId?: number | null;
  headImageUrl?: string;
  introduction?: string;
  name?: string;
  prompt?: string;
  type?: string;
  isPublic?: string;
  fileName?: string;
}
function roleAdd(param: RoleAddCheck) {
  return service({
    method: "post",
    url: "/api/chat/web/app/add",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}

interface MyRoleCheck {
  pageNo?: number;
  pageSize?: number;
}
function myRole(param: MyRoleCheck) {
  return service({
    method: "get",
    url: "/api/chat/web/app/my",
    params: param,
  });
}

interface RoleDetailCheck {
  code?: string;
  allowCancel?: boolean;
}
const roleDetail = async (param: RoleDetailCheck) => {
  return await service({
    method: "get",
    url: "/api/chat/web/app/role/detail",
    params: param,
  });
};

const roleHeighDetail = async (param: RoleDetailCheck) => {
  return await service({
    method: "get",
    url: "/api/chat/web/app/role/senior/detail",
    params: param,
  });
};
interface ApiKeyCheck {
  name?: string;
}
const apiKey = async (param?: ApiKeyCheck) => {
  // return await service({
  //   method: "get",
  //   url: "/api/chat/web/app/user/create/api/key",
  // });
  return service({
    method: "post",
    url: "/api/chat/web/app/user/create/api/key",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const apiKeyList = async () => {
  return await service({
    method: "get",
    url: "/api/chat/web/app/user/create/api/key",
  });
};

interface ChangeRoleSwitchCheck {
  code?: string;
  isDisplayOnAppSquare?: string;
}
const changeRoleSwitch = async (param: ChangeRoleSwitchCheck) => {
  return await service({
    method: "get",
    url: "/api/chat/web/app/role/switch",
    params: param,
  });
};

// 修改用户资料
interface UserUpdateCheck {
  nickName?: string;
  headImageUrl?: string;
}
const userUpdate = async (param: UserUpdateCheck) => {
  return await service({
    method: "post",
    url: "/api/chat/web/app/user/update",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
    data: param,
  });
};

interface UserEditUpdateCheck {
  code?: string;
  description?: string;
  displayOnAppSquare?: boolean;
  groupId?: number;
  headImageUrl?: string;
  introduction?: string;
  name?: string;
  prompt?: string;
  textUrl?: string;
  type?: string;
  temperature?: number;
  similarity?: string;
  reply_strategy?: string;
}
const userEditUpdate = async (param: UserEditUpdateCheck) => {
  return await service({
    method: "post",
    url: "/api/chat/web/app/update",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const getProduct = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/chat/web/app/user/getProduct",
    params: param,
  });
};

interface rechargeOrderCheck {
  code?: string;
  goodId?: string;
  payChannel?: string;
}
const rechargeOrder = async (param: rechargeOrderCheck) => {
  return await service({
    method: "post",
    url: "/api/chat/web/app/user/createOrder",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const getBalance = async () => {
  return await service({
    method: "get",
    url: "/api/chat/web/app/user/get/balance",
  });
};

interface GetUserOrderCheck {
  pageNo?: number;
  pageSize?: number;
}
const getUserOrder = async (param: GetUserOrderCheck) => {
  return await service({
    method: "get",
    url: "/api/chat/web/app/user/getOrder",
    params: param,
  });
};
interface GetRecordDetailCheck {
  orderNo?: string;
}
const getRecordDetail = async (param: GetRecordDetailCheck) => {
  return await service({
    method: "get",
    url: "/api/chat/web/app/user/order/detail",
    params: param,
  });
};

interface queryFormCheck {
  pageNo?: number;
  pageSize?: number;
  appCode?: string;
  endTime?: string;
  model?: string;
  source?: string;
  startTime?: string;
  type?: string;
}
const getInvokeRecord = async (param: queryFormCheck) => {
  return await service({
    method: "get",
    url: "/api/chat/web/getInvokeRecord",
    params: param,
  });
};

const getScoreAll = async (param: queryFormCheck) => {
  return service({
    url: "/api/chat/web/queryInvokeRecordAllUsedScore",
    method: "get",
    params: param,
  });
};
const getAgentRunTrace = async (agentRunId: string) => {
  return await service({
    method: "get",
    url: "/api/chat/web/getAgentRunTrace",
    params: { agentRunId },
  });
};
const getInvokeRecordEnum = async () => {
  return await service({
    method: "get",
    url: "/api/chat/web/getInvokeRecordQueryParamEnum",
  });
};
interface DeleteFileCheck {
  appCode?: string;
  fileId?: string;
}
const deleteFile = async (param: DeleteFileCheck) => {
  return await service({
    method: "post",
    url: "/api/web/data/delete",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

interface BatchDeleteFileCheck {
  fileIds: string[];
  appCode?: string;
}
const batchDeleteFile = async (param: BatchDeleteFileCheck) => {
  return await service({
    method: "post",
    url: "/api/web/knowledge/base/file/batch/delete",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

interface AddFileCheck {
  code?: string;
  url?: string;
  originFileName?: string;
}
const addFile = async (param: AddFileCheck) => {
  return await service({
    method: "post",
    url: "/api/web/embedding",
    data: JSON.stringify(param),
    timeout: 5 * 6 * 10000,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

interface appCodeCheck {
  appCode?: string;
  // Clear only this conversation's context instead of the app-wide one.
  sessionId?: string;
}

const deleteRole = async (param: appCodeCheck) => {
  return await service({
    method: "delete",
    url: "/api/chat/web/app/delete/role",
    params: param,
  });
};

// const weXinLogin = async () => {
//   return await service({
//     method: "get",
//     url: "/api/wx/OAuth/login/getAuthUrl",
//   });
// };
interface getCodeCheck {
  code?: string;
  share?: string;
}
const applyTokenByCode = async (param: getCodeCheck) => {
  return await service({
    method: "get",
    url: "/api/wx/OAuth/login/apply/token",
    params: param,
  });
};

const uploadLinkFile = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/upload",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: param,
  });
};
const uploadFile = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/cdnUpload",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: param,
  });
};
const uploadImage = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/media/upload",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: param,
  });
};
const deleteContext = async (param: appCodeCheck) => {
  return await service({
    method: "post",
    url: "/api/web/chat/context/delete",
    headers: {
      "Content-Type": "application/json",
    },
    data: param,
  });
};

interface deleteAppKeyCheck {
  id?: string;
}
const deleteAppKey = async (param: deleteAppKeyCheck) => {
  return await service({
    method: "delete",
    url: "/api/chat/web/app/user/delete/api/key",
    params: param,
  });
};

interface fileListCheck {
  appCode?: string;
  fileId?: string;
  pageNo?: number;
  pageSize?: number;
  keyword?: string;
  itemId?: string;
}
const queryfileList = async (param: fileListCheck) => {
  return await service({
    method: "post",
    url: "/api/web/data/list",
    headers: {
      "Content-Type": "application/json",
    },
    data: param,
  });
};
interface editFileListCheck {
  id?: string;
  appCode?: string;
  fileId?: string;
  text?: string;
  question?: string;
  string?: string;
  onlySearchQuestion?: any;
}

const editfileList = async (param: editFileListCheck) => {
  return await service({
    method: "post",
    url: "/api/web/data/edit",
    headers: {
      "Content-Type": "application/json",
    },
    data: param,
  });
};

interface addFileListCheck {
  appCode?: string;
  fileId?: string;
  text?: string;
  question?: string;
  string?: string;
  onlySearchQuestion?: any;
}

const addFileList = async (param: addFileListCheck) => {
  return await service({
    method: "post",
    url: "/api/web/data/add",
    headers: {
      "Content-Type": "application/json",
    },
    data: param,
  });
};
interface deleteFileListCheck {
  id?: string;
  appCode?: string;
  fileId?: string;
}
const deleteFileList = async (param: deleteFileListCheck) => {
  return await service({
    method: "post",
    url: "/api/web/data/text/delete",
    headers: {
      "Content-Type": "application/json",
    },
    data: param,
  });
};

interface paintForm {
  prompt?: string;
  mode?: string;
  auto_translate?: boolean;
}
const paintMsg = async (param: paintForm) => {
  return await service({
    method: "post",
    url: "/v1/img/web/midjourney/generate",
    headers: {
      "Content-Type": "application/json",
    },
    data: param,
  });
};

interface imgDetailCheck {
  type?: string;
  img_id?: string;
  index?: boolean;
}

const imgDetail = async (param: imgDetailCheck) => {
  return await service({
    method: "post",
    url: "/v1/img/web/midjourney/operate",
    headers: {
      "Content-Type": "application/json",
    },
    data: param,
  });
};
interface getMsgCheck {
  task_id?: string;
}
const getImg = async (param: getMsgCheck) => {
  return await service({
    method: "get",
    url: `/v1/img/web/midjourney/tasks/${param.task_id}`,
  });
};

const sendRhyPostInfo = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/voice/stream",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    responseType: "blob",
    data: param,
  });
};

const sendRhygetInfo = async () => {
  return await service({
    method: "get",
    url: "/api/web/tts/stream?text=告诉我你的想法",
    responseType: "blob",
  });
};

interface appCheck {
  appCode?: string;
}
const getModel = async (param: appCheck) => {
  return await service({
    method: "get",
    url: `/api/web/app/models?appCode=${param.appCode}`,
  });
};

interface loginCheck {
  username: string;
  password: string;
}

const passwordLogin = async (param: loginCheck) => {
  return await service({
    method: "post",
    url: "/api/login",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
    data: param,
  });
};
interface verificationCodeCheck {
  phoneNumber: string;
}
const getVerificationCode = async (param: verificationCodeCheck) => {
  return await service({
    method: "get",
    url: "/api/get/verification/code",
    params: param,
  });
};

// 注册
interface registerCheck {
  accountNo: string;
  password: string;
  verificationCode: string;
  shareUserId?: string;
}

const registerAccount = async (param: registerCheck) => {
  return await service({
    method: "post",
    url: "/api/register",
    headers: {
      "Content-Type": "application/json",
    },
    data: param,
  });
};

interface updatePasswordCheck {
  accountNo?: string;
  newPassword?: string;
  oldPassword?: string;
  verificationCode?: string;
}
const updatePassword = async (param?: updatePasswordCheck) => {
  return service({
    method: "post",
    url: "/api/chat/web/app/user/update/password",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const forgetPwd = async (param?: updatePasswordCheck) => {
  return service({
    method: "post",
    url: "/api/forget/password",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const signDay = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/chat/web/app/user/sign/in",
    params: param,
  });
};

const weChatPay = async (param: any) => {
  return service({
    method: "post",
    url: "/api/chat/wx/createOrder",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

interface bindPubilc {
  accountNo: string;
}
const bindPubilcPhone = async (param: bindPubilc) => {
  return await service({
    method: "get",
    url: "/api/wx/public/login/getWeChatPublicAccountImageBase64ToBindAccount",
    params: param,
  });
};

const queryBase = async (param?: any) => {
  return service({
    method: "post",
    url: "/api/web/knowledge/base/create",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const benefitsList = async (param: GetUserOrderCheck) => {
  return await service({
    method: "get",
    url: "/api/chat/web/benefits/list",
    params: param,
  });
};

const benefitsAccount = async () => {
  return await service({
    method: "get",
    url: "/api/chat/web/benefits/account",
  });
};

const invitationCode = async () => {
  return await service({
    method: "get",
    url: "/api/chat/web/app/user/get/invitation/code",
  });
};

// 不传 folder_code 时返回全部知识库，与目录改造前的行为一致
interface baseListCheck {
  folder_code?: string;
  include_sub?: boolean;
}

const getBaseList = async (param?: baseListCheck) => {
  return await service({
    method: "get",
    url: "/api/web/knowledge/base/list",
    params: param,
  });
};

interface createBaseCheck {
  name: string;
  desc: string;
  folderCode?: string;
}

const createBaseApi = async (param: createBaseCheck) => {
  return await service({
    method: "post",
    url: "/api/web/knowledge/base/create",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

/* ------------------------- 知识库目录 ------------------------- */

// 响应拦截器 return 的是 response.data，但它的签名仍写着 AxiosResponse，
// 类型与运行时不符。目录相关接口显式标注业务体类型，调用处才能直接读 success。
export interface ApiResult<T = any> {
  success: boolean;
  code: number;
  message: string;
  data: T;
}

const asResult = <T>(resp: unknown) => resp as unknown as ApiResult<T>;

// 目录树节点。FOLDER 与 BASE 同构，便于 el-tree 直接渲染混合树；
// VIRTUAL 只有「全部知识库」这一个根节点，没有对应的目录记录。
export interface KnowledgeTreeNode {
  code: string;
  name: string;
  nodeType: "FOLDER" | "BASE" | "VIRTUAL";
  parentCode: string;
  path?: string;
  level?: number;
  baseCount?: number;
  desc?: string;
  iconUrl?: string;
  fileCount?: number;
  createTime?: string;
  updateTime?: string;
  children?: KnowledgeTreeNode[];
}

const getKnowledgeFolderTree = async (param?: { with_base?: boolean }) => {
  return asResult<KnowledgeTreeNode[]>(
    await service({
      method: "get",
      url: "/api/web/knowledge/folder/tree",
      params: param,
    })
  );
};

// 与 /api/web/knowledge/base/list 的单条记录同构
export interface KnowledgeBaseItem {
  code: string;
  name: string;
  desc: string;
  folder_code?: string;
  file_count?: number;
  icon_url?: string;
  create_time: string;
  update_time: string;
}

export interface KnowledgeFolderChildren {
  folderCode: string;
  // 当前目录的描述，虚拟节点为空串
  desc: string;
  breadcrumb: { code: string; name: string }[];
  // 分页只针对知识库，每一页都带着全部目录
  folders: KnowledgeTreeNode[];
  bases: KnowledgeBaseItem[];
  // 两个总数都是全部页的合计
  total: number;
  folderTotal?: number;
  // 后端会把越界的页码收回到最后一页，以这里回传的为准
  pageNo?: number;
  pageSize?: number;
  // 非空表示这是搜索结果（当前目录整棵子树），而不是直接子项
  keyword?: string;
}

// 不传 page_size 时不分页，返回全部
const getKnowledgeFolderChildren = async (param?: {
  folder_code?: string;
  keyword?: string;
  page_no?: number;
  page_size?: number;
}) => {
  return asResult<KnowledgeFolderChildren>(
    await service({
      method: "get",
      url: "/api/web/knowledge/folder/children",
      params: param,
    })
  );
};

// 返回新建目录的 code
const createKnowledgeFolder = async (param: {
  name: string;
  desc?: string;
  parentCode?: string;
}) => {
  return asResult<string>(
    await service({
      method: "post",
      url: "/api/web/knowledge/folder/create",
      data: JSON.stringify(param),
      headers: {
        "Content-Type": "application/json",
      },
    })
  );
};

const updateKnowledgeFolder = async (param: {
  code: string;
  name: string;
  desc?: string;
}) => {
  return asResult<null>(
    await service({
      method: "post",
      url: "/api/web/knowledge/folder/update",
      data: JSON.stringify(param),
      headers: {
        "Content-Type": "application/json",
      },
    })
  );
};

const moveKnowledgeFolder = async (param: {
  code: string;
  targetParentCode?: string;
}) => {
  return asResult<null>(
    await service({
      method: "post",
      url: "/api/web/knowledge/folder/move",
      data: JSON.stringify(param),
      headers: {
        "Content-Type": "application/json",
      },
    })
  );
};

// codes 要给出该父目录下同级目录的完整顺序，parentCode 为空串表示根目录
const sortKnowledgeFolder = async (param: {
  parentCode?: string;
  codes: string[];
}) => {
  return asResult<{ sorted: number } | null>(
    await service({
      method: "post",
      url: "/api/web/knowledge/folder/sort",
      data: JSON.stringify(param),
      headers: {
        "Content-Type": "application/json",
      },
    })
  );
};

const deleteKnowledgeFolder = async (param: {
  code: string;
  recursive?: boolean;
}) => {
  return asResult<{ deletedFolders: number; deletedBases: number } | null>(
    await service({
      method: "post",
      url: "/api/web/knowledge/folder/delete",
      data: JSON.stringify(param),
      headers: {
        "Content-Type": "application/json",
      },
    })
  );
};

// 批量接口逐个执行、不整批回滚，failedItems 里是没成功的那几个及原因
interface KnowledgeFolderBatchFailure {
  code: string;
  name: string;
  msg: string;
}

const batchMoveKnowledgeFolder = async (param: {
  codes: string[];
  targetParentCode?: string;
}) => {
  return asResult<{
    moved: number;
    failed: number;
    failedItems: KnowledgeFolderBatchFailure[];
  } | null>(
    await service({
      method: "post",
      url: "/api/web/knowledge/folder/batch/move",
      data: JSON.stringify(param),
      headers: {
        "Content-Type": "application/json",
      },
    })
  );
};

const batchDeleteKnowledgeFolder = async (param: { codes: string[] }) => {
  return asResult<{
    deletedFolders: number;
    deletedBases: number;
    failed: number;
    failedItems: KnowledgeFolderBatchFailure[];
  } | null>(
    await service({
      method: "post",
      url: "/api/web/knowledge/folder/batch/delete",
      data: JSON.stringify(param),
      headers: {
        "Content-Type": "application/json",
      },
    })
  );
};

const moveKnowledgeBase = async (param: {
  codes: string[];
  targetFolderCode?: string;
}) => {
  return asResult<{ moved: number } | null>(
    await service({
      method: "post",
      url: "/api/web/knowledge/base/move",
      data: JSON.stringify(param),
      headers: {
        "Content-Type": "application/json",
      },
    })
  );
};

const batchDeleteBase = async (param: { codes: string[] }) => {
  return asResult<{
    deleted: number;
    failed: number;
    failedCodes: string[];
  } | null>(
    await service({
      method: "post",
      url: "/api/web/knowledge/base/batch/delete",
      data: JSON.stringify(param),
      headers: {
        "Content-Type": "application/json",
      },
    })
  );
};

interface parseBaseCheck {
  chunkSize: number;
  url: string;
}

const parseBase = async (param: parseBaseCheck) => {
  return await service({
    method: "post",
    url: "/api/web/knowledge/base/file/parse",
    data: JSON.stringify(param),
    timeout: 5 * 6 * 10 * 1000,
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const newParseWeb = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/knowledge/base/website/parse",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
interface baseListCheck {
  code: string;
  page_no: number;
  page_size: number;
}

const baseList = async (param: baseListCheck) => {
  return await service({
    method: "get",
    url: "/api/web/knowledge/base/file/list",
    params: param,
  });
};

interface filesCheck {
  url: string;
  originFileName: string;
}
interface embeddingCheck {
  code: string;
  chunkSize: number;
  files: filesCheck[];
  onlySearchQuestion?: any;
}

const embeddingExport = async (param: embeddingCheck) => {
  return await service({
    method: "post",
    url: "/api/web/knowledge/base/file/embedding",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

interface baseSearchCheck {
  code: string;
  query: string;
  k: number;
}

const baseSearch = async (param: baseSearchCheck) => {
  return await service({
    method: "post",
    url: "/api/web/knowledge/base/search",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

interface cashoutParam {
  amount: number;
  type: string;
}

const cashOut = async (param: cashoutParam) => {
  return await service({
    method: "post",
    url: "/api/chat/web/benefits/cashout",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

interface baseRelationCheck {
  appCode: string;
  dataCode: string;
}

const bindBase = async (param: baseRelationCheck) => {
  return await service({
    method: "post",
    url: "/api/chat/web/app/knowledge/base/relation/add",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const deleteBaseApi = async (param: baseRelationCheck) => {
  return await service({
    method: "post",
    url: "/api/chat/web/app/knowledge/base/relation/delete",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// Without `modelTypeList` the backend only returns chat models (model_type LIKE
// '%LLM%'), which is what every caller but the intent-branch picker wants.
// Spring MVC binds the list from a repeated key, so the array has to be
// serialized as `modelTypeList=LLM&modelTypeList=JUDGE`; axios would otherwise
// emit `modelTypeList[]=`, which binds to nothing.
const getAllModel = async (modelTypeList?: string[]) => {
  return await service({
    method: "get",
    url: "/api/chat/web/app/all/ai/model/v2",
    params:
      modelTypeList && modelTypeList.length ? { modelTypeList } : undefined,
    paramsSerializer: { indexes: null },
  });
};

const baseDetial = async (param: RoleDetailCheck) => {
  return await service({
    method: "get",
    url: "/api/web/knowledge/base/detail",
    params: param,
  });
};

const baseDetele = async (param: RoleDetailCheck) => {
  return await service({
    method: "post",
    url: "/api/web/knowledge/base/delete",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
interface updataBaseCheck {
  code: string;
  iconUrl: string;
  name: string;
  desc: string;
}
const updataBase = async (param: updataBaseCheck) => {
  return await service({
    method: "post",
    url: "/api/web/knowledge/base/update",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const roleThumb = async (param: appCheck) => {
  return await service({
    method: "get",
    url: "/api/chat/web/app/role/thumb",
    params: param,
  });
};

const roleCollection = async (param: appCheck) => {
  return await service({
    method: "get",
    url: "/api/chat/web/app/role/collection",
    params: param,
  });
};

// 插件接口
const allPluginsList = async (param?: any) => {
  return await service({
    method: "post",
    url: `/api/chat/web/app/plugins/template/list${param ? "?scope=" + param.scope : ""
      }`,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const pluginsList = async (param: appCodeCheck) => {
  return await service({
    method: "post",
    url: "/api/chat/web/app/plugins/list",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
    data: param,
  });
};

interface addPluginsCheck {
  appCode?: string;
  args?: string;
  config?: string;
  enabled?: string;
  id?: number;
  pluginId?: number;
  code?: string;
}
const addPlugins = async (param: addPluginsCheck) => {
  return await service({
    method: "post",
    url: "/api/chat/web/app/plugins/insert",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};

interface deletePulginCheck {
  id: string;
}

const deletePulgins = async (param: deletePulginCheck) => {
  return await service({
    method: "post",
    url: "/api/chat/web/app/plugins/delete",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
    data: param,
  });
};

const pluginSwitch = async (param: addPluginsCheck) => {
  return await service({
    method: "post",
    url: "/api/chat/web/app/plugins/switch",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};

// userKey

const queryUserKey = async () => {
  return await service({
    method: "get",
    url: "/api/chat/web/app/user/query/user/key",
  });
};

interface createUserKeyCheck {
  id?: number;
  name?: string;
  subType?: string;
  type?: string;
  userId?: number;
  userKey?: string;
}
const createUserKey = async (param: createUserKeyCheck) => {
  return await service({
    method: "post",
    url: "/api/chat/web/app/user/create/user/key",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};

const editUserKey = async (param: createUserKeyCheck) => {
  return await service({
    method: "post",
    url: "/api/chat/web/app/user/update/user/key",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};

interface deleteUserKeyCheck {
  id?: string;
}
const deleteUserKey = async (param: deleteUserKeyCheck) => {
  return await service({
    method: "delete",
    url: "/api/chat/web/app/user/delete/user/key",
    params: param,
  });
};

const deletePlugin = async (param: deleteUserKeyCheck) => {
  return await service({
    method: "delete",
    url: "/api/chat/web/plugin/delete",
    params: param,
  });
};

// One page of the voices the caller may use, for the picker on an app or a
// workflow end node. Paged rather than fetched whole: the two 豆包 generations
// alone run to 150-odd voices, each with an avatar and an audition clip.
// `selected` is an ai_voice_tone id.
const voiceTonePage = async (param: {
  vendor?: string;
  keyword?: string;
  page_no?: number;
  page_size?: number;
  selected?: string;
}) => {
  return await service({
    method: "get",
    url: "/api/web/voice/tones",
    params: param,
  });
};
// 获取试听地址

const getVoiceDemo = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/web/voice/demo",
    params: param,
  });
};
interface autoCreateCheck {
  name: string;
  description: string;
}
const autoCreateImg = async (param: autoCreateCheck) => {
  return await service({
    method: "post",
    url: "/api/web/app/avatar/autoCreate",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
// 创建应用/工作流的可选预置头像（bizType: APP | WORKFLOW）
const getPresetAvatars = async (bizType = "APP") => {
  return await service({
    method: "get",
    url: "/api/chat/web/app/preset/avatars",
    params: { bizType },
  });
};
const autoCreate = async (param: autoCreateCheck) => {
  return await service({
    method: "post",
    url: "/api/web/app/autoCreate",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
interface createFileCheck {
  fileName: string;
  type: string;
  dataCode?: string;
}
const createFile = async (param: createFileCheck) => {
  return await service({
    method: "post",
    url: "/api/web/file/create",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};

interface exportFilesCheck {
  fileId: string;
}
const exportFiles = async (param: exportFilesCheck) => {
  return await service({
    method: "post",
    url: "/api/web/file/export",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};

const exportFileInvokeRecord = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/chat/web/exportInvokeRecord",
    responseType: "blob",
    params: param,
  });
};
// 导出知识库未命中
const exportNotHitKnowledgeInvokeRecord = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/exportNotHitKnowledgeInvokeRecord",
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
    },
    data: param,
  });
};
// 导出转人工记录
const exportTransferManualInvokeRecord = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/exportTransferManualInvokeRecord",
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
    },
    data: param,
  });
};
// 导出高频词
const exportHighFrequencyWordRecord = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/export/highFrequencyWordRecord",
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
    },
    data: param,
  });
};
interface renameCheck {
  fileName: string;
  fileId: string;
}
const reName = async (param: renameCheck) => {
  return await service({
    method: "post",
    url: "/api/web/file/rename",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};

const addCusPlugin = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/plugin/add",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const editCusPlugin = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/plugin/update",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
// 通道查询
const apiGetChannelList = async () => {
  return service({
    url: "/api/control/channel/list",
    method: "get",
  });
};

const apiGetChannelTag = async (param: any) => {
  return service({
    url: "/api/web/hosting/account/tags",
    method: "get",
    params: param,
  });
};

const apiGetFriendList = async (param: any) => {
  return service({
    url: "/api/web/hosting/tag/friend/list",
    method: "get",
    params: param,
  });
};
const apiGetSessionList = async (param: any) => {
  return service({
    url: "/api/control/msg/session/list",
    method: "get",
    params: param,
  });
};
const apiGetHistoryList = async (param: any) => {
  return service({
    url: "/api/control/msg/session/history",
    method: "get",
    params: param,
  });
};

const apiMessagePush = async (param: any) => {
  return service({
    url: "/api/control/msg/push",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};

const apiMessageRead = async (param: any) => {
  return service({
    url: "/api/control/msg/read",
    method: "get",
    params: param,
  });
};

const apiGetCompanyInviteUrl = async (param: any) => {
  return service({
    url: "/api/chat/web/company/inviteMember",
    method: "get",
    params: param,
  });
};
const getCompanyMember = async (param: any) => {
  return service({
    url: "/api/chat/web/company/getCompanyMember",
    method: "post",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const getDepartmentTree = async () => {
  return service({
    url: "/api/chat/web/company/department/tree",
    method: "get",
  });
};

const addDepartment = async (param: any) => {
  return service({
    url: "/api/chat/web/company/department/add",
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(param),
  });
};

const updateDepartment = async (param: any) => {
  return service({
    url: "/api/chat/web/company/department/update",
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(param),
  });
};

const moveDepartment = async (param: any) => {
  return service({
    url: "/api/chat/web/company/department/move",
    method: "post",
    params: param,
  });
};

const deleteDepartment = async (param: any) => {
  return service({
    url: "/api/chat/web/company/department/delete",
    method: "delete",
    params: param,
  });
};

const assignMemberDepartment = async (param: any) => {
  return service({
    url: "/api/chat/web/company/department/member/assign",
    method: "post",
    params: param,
  });
};

const batchAssignMemberDepartment = async (param: any) => {
  return service({
    url: "/api/chat/web/company/department/member/batchAssign",
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(param),
  });
};

const removeMemberDepartment = async (param: any) => {
  return service({
    url: "/api/chat/web/company/department/member/remove",
    method: "post",
    params: param,
  });
};

const addCompany = async (param: any) => {
  return service({
    url: "/api/chat/web/company/add",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const getUserPrivilege = async () => {
  return service({
    url: "/api/chat/web/user/privilege",
    method: "get",
  });
};

const getMemberPrivige = async () => {
  return service({
    url: "/api/chat/web/company/getMemberPrivilege",
    method: "get",
  });
};
const getUseMemberPrivige = async () => {
  return service({
    url: "/api/chat/web/company/getUseMemberPrivilege",
    method: "get",
  });
};

const getUseMemberPrivilegeCost = async () => {
  return service({
    url: "/api/chat/web/company/getUseMemberPrivilegeCost",
    method: "get",
  });
};
const getRolePrivige = async (param: any) => {
  return service({
    url: "/api/chat/web/company/getCompanyRole",
    method: "get",
    params: param,
  });
};

const geCompanyIvite = async (param: any) => {
  return service({
    url: "/api/chat/web/company/getCompanyByInviteParam",
    method: "get",
    params: param,
  });
};
interface botChatParam {
  clientId?: string;
}
const getMetaData = async (param: botChatParam) => {
  return await service({
    method: "get",
    url: "/api/web/integration/metadata",
    params: param,
  });
};
// 获取web集成list
const getWebAppList = async (param: any) => {
  return service({
    url: "/api/chat/web/integration/list",
    method: "get",
    params: param,
  });
};
// web集成创建
const createWebapp = async (param: any) => {
  return service({
    url: "/api/chat/web/integration/create",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};

// 获取web集成详情
const getWebAppDetail = async (param: any) => {
  return service({
    url: "/api/chat/web/integration/detail",
    method: "get",
    params: param,
  });
};

const agreeEnterCompany = async (param: any) => {
  return service({
    url: "/api/chat/web/company/agreeEnterCompany",
    method: "get",
    params: param,
  });
};
// web集成更新
const updateWebapp = async (param: any) => {
  return service({
    url: "/api/chat/web/integration/update",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};

// web集成删除
const deleteWebapp = async (param: any) => {
  return service({
    url: "/api/chat/web/integration/delete",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const getCompanyDetail = async () => {
  return service({
    url: "/api/chat/web/company/detail",
    method: "get",
  });
};

const editClient = async (param: any) => {
  return service({
    url: "/api/control/channel/update",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const deleteClientApi = async (param: any) => {
  return service({
    url: "/api/control/channel/delete",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const updataQrUrl = async (param: any) => {
  return service({
    url: "/api/control/channel/status",
    method: "get",
    params: param,
  });
};
const getMediaList = async (param: any) => {
  return service({
    url: "/api/chat/web/media/list",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
    data: param,
  });
};
const deleteMedia = async (param: any) => {
  return await service({
    method: "delete",
    url: "/api/chat/web/media/delete",
    params: param,
  });
};

const configDetail = async (param: any) => {
  return await service({
    url: "/api/control/channel/config/detail",
    method: "get",
    params: param,
  });
};

const configSave = async (param: any) => {
  return await service({
    url: "/api/control/channel/config/save",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const getAccountList = async (param: any) => {
  return await service({
    url: "/api/web/hosting/account/list",
    method: "get",
    params: param,
  });
};

const getAccountAppDetail = async (param: any) => {
  return await service({
    url: "/api/web/hosting/config/private/info",
    method: "get",
    params: param,
  });
};
const getGroupList = async (param: any) => {
  return await service({
    url: "/api/web/hosting/group/list",
    method: "get",
    params: param,
  });
};

const onHostingPost = async (param: any) => {
  return await service({
    url: "/api/web/hosting/account/on",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};

const offHostingPost = async (param: any) => {
  return await service({
    url: "/api/web/hosting/account/off",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};

const onHostingGroupPost = async (param: any) => {
  return await service({
    url: "/api/web/hosting/group/on",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};

const offHostingGroupPost = async (param: any) => {
  return await service({
    url: "/api/web/hosting/group/off",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};

const updateAccountAppCode = async (param: any) => {
  return await service({
    url: "/api/web/hosting/account/app_code",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const updateGroupAppCode = async (param: any) => {
  return await service({
    url: "/api/web/hosting/group/app_code",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const synWaitOpen = async (param: any) => {
  return await service({
    url: "/api/web/hosting/group/syn_wait_open",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const addAppLimitConfig = async (param: any) => {
  return await service({
    url: "/api/chat/web/rate/limit/add",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const getAdvancedConfigQuerg = async (param: any) => {
  return await service({
    url: "/api/chat/web/app/role/advanced/config/detail",
    method: "get",
    params: param,
  });
};

const getCompanyNotifyMember = async () => {
  return await service({
    url: "/api/chat/web/company/getCompanyNotifyMember",
    method: "get",
  });
};

const saveAdvancedConfig = async (param: any) => {
  return await service({
    url: "/api/chat/web/app/role/advanced/config/update",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const deleteAppLimitConfig = async (param: any) => {
  return await service({
    url: "/api/chat/web/rate/limit/delete",
    method: "delete",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
    data: param,
  });
};
const queryAppLimitConfig = async (param: any) => {
  return await service({
    url: "/api/chat/web/rate/limit/query",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
    data: param,
  });
};
const updateAppLimitConfig = async (param: any) => {
  return await service({
    url: "/api/chat/web/rate/limit/update",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const changeUserService = async (param: any) => {
  return await service({
    url: "/api/control/channel/sender/serviceMode/update",
    method: "get",
    params: param,
  });
};
const getSessionList = async (param: any) => {
  return await service({
    url: "/api/control/msg/session/manual/list",
    method: "get",
    params: param,
  });
};

const getHostingArea = async () => {
  return await service({
    url: "/api/web/hosting/area",
    method: "get",
  });
};

const getLoginQrcode = async (param: any) => {
  return await service({
    url: "/api/web/hosting/login/qr_code",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};

const getHostingStatus = async (param: any) => {
  return await service({
    url: "/api/web/hosting/login/status",
    method: "get",
    params: param,
  });
};
const getWorkFlowDetail = async (param: any) => {
  return await service({
    url: "/api/web/workflow/detail",
    method: "get",
    params: param,
  });
};

const getHostingOffline = async (param: any) => {
  return await service({
    url: "/api/web/hosting/login/submit_verify_code",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const offlineHostingAccount = async (param: any) => {
  return await service({
    url: "/api/web/hosting/account/offline",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const saveWorkFlowDetail = async (param: any) => {
  return await service({
    url: "/api/web/workflow/save",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};

const clientConfig = async (param: any) => {
  return await service({
    url: "/api/control/channel/create/client/config",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const createWorkFlowDetail = async (param: any) => {
  return await service({
    url: "/api/web/workflow/create",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const deleteWorkFlowDetail = async (param: any) => {
  return await service({
    url: "/api/web/workflow/delete",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const workflowRun = async (param: any) => {
  return await service({
    url: "/api/web/workflow/run",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const worFlowList = async () => {
  return await service({
    url: "/api/web/workflow/list",
    method: "get",
  });
};
const getCronGenerate = async (param: any) => {
  return await service({
    url: "/api/web/workflow/cron/generate",
    method: "get",
    params: param,
  });
};

const runCronGenerate = async (param: any) => {
  return await service({
    url: "/api/web/workflow/cron/run",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};

const getFriendList = async (param: any) => {
  return await service({
    url: "/api/web/hosting/friend/list",
    method: "get",
    params: param,
  });
};
const getNewFriendList = async (param: any) => {
  return await service({
    url: "/api/chat/web/customer/list/robot",
    method: "get",
    params: param,
  });
};

const queryRobotList = async (param: any) => {
  return await service({
    url: "/api/chat/web/customer/list/robot/in",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const editFlowDetail = async (param: any) => {
  return await service({
    url: "/api/web/workflow/info/edit",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const getTimeRun = async (param: any) => {
  return await service({
    url: "/api/web/workflow/scheduler/detail",
    method: "get",
    params: param,
  });
};
const addTimeRun = async (param: any) => {
  return await service({
    url: "/api/web/workflow/scheduler/add",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const editTimeRun = async (param: any) => {
  return await service({
    url: "/api/web/workflow/scheduler/edit",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const deleteTimeRun = async (param: any) => {
  return await service({
    url: "/api/web/workflow/scheduler/delete",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const saveTimeRun = async (param: any) => {
  return await service({
    url: "/api/web/workflow/scheduler/save",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const getByScene = async (param: any) => {
  return await service({
    url: "/api/chat/web/threshold/config/getByScene",
    method: "get",
    params: param,
  });
};

const addByScene = async (param: any) => {
  return await service({
    url: "/api/chat/web/threshold/config/add",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};

const updateByScene = async (param: any) => {
  return await service({
    url: "/api/chat/web/threshold/config/update",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const hitSwitchByScene = async (param: any) => {
  return await service({
    url: "/api/chat/web/threshold/config/hitSwitch",
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
    data: param,
  });
};
const getNoticeList = async (param: any) => {
  return await service({
    url: "/api/chat/web/announcement/list",
    method: "get",
    params: param,
  });
};
const postReadNotice = async (param: any) => {
  return await service({
    url: "/api/chat/web/announcement/read",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const postReadNoticeAll = async () => {
  return await service({
    url: "/api/chat/web/announcement/read/all",
    method: "get",
  });
};

const getStatistics = async () => {
  return await service({
    url: "/api/chat/web/announcement/get/announcement/statistics",
    method: "get",
  });
};

interface tableColums {
  fileId: string;
  columns?: any;
}
const editTableColums = async (param: tableColums) => {
  return await service({
    method: "post",
    url: "/api/web/knowledge/table/columns/edit",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const tableViewAddColums = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/data/add",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const tableViewEditColums = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/data/edit",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const submitInvite = async (param: any) => {
  return await service({
    method: "post",
    url: " /api/chat/web/invite/submit",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const getFindByFileId = async (param: any) => {
  return await service({
    url: "/api/web/knowledge/base/findByFileId",
    method: "get",
    params: param,
  });
};
// 用户数量统计
const getUseUserCount = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/data/board/useUserCount",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 对话渠道数量统计
const getRecordChannelCount = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/data/board/recordChannelCount",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 对话数量统计
const getRecordCount = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/data/board/recordCount",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 对话数量统计(未命中知识库)
const getRecordNotHitKnowledgeBaseCount = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/data/board/recordNotHitKnowledgeBaseCount",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 积分消耗数量统计
const getScoreCostCount = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/data/board/scoreCostCount",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 转人工数量统计
const getTransferManualCount = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/data/board/transferManualCount",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

/* ============================================================
 * 数据大屏 V2（DashboardV2）接口
 * 路由前缀：/api/chat/web/dashboard/v2
 * 通用请求参数：DashboardV2Request（startDate/endDate 必填）
 * 通用返回：{ success, code, message, data }
 * 服务端已做 5s Redis 缓存，可放心 1-2s 轮询
 * ============================================================ */
export interface DashboardV2Request {
  dateType?: "DAY" | "WEEK" | "MONTH";
  startDate: string;
  endDate: string;
  departmentId?: number | null;
  memberUserIds?: number[];
  modelInnerCodes?: string[];
  supplierCodes?: string[];
  categories?: ("TEXT" | "IMAGE" | "VIDEO" | "VOICE")[];
  recordTypes?: string[];
  appCodes?: string[];
  channelTypes?: string[];
  limit?: number;
  orderBy?: "call_count" | "total_score" | "total_tokens";
}

const DASHBOARD_V2_BASE = "/api/chat/web/dashboard/v2";

const postDashboardV2 = (path: string, param: DashboardV2Request) =>
  service({
    method: "post",
    url: `${DASHBOARD_V2_BASE}/${path}`,
    data: JSON.stringify(param ?? {}),
    headers: { "Content-Type": "application/json" },
  });

// K1：AI 调用 KPI（活跃成员/调用数/token/积分/耗时…）
const dashboardAiUsageSummary = (param: DashboardV2Request) =>
  postDashboardV2("aiUsageSummary", param);

// K2/K3/K4/K5：内容创作 KPI（4 大类 + 视频时长）
const dashboardContentSummary = (param: DashboardV2Request) =>
  postDashboardV2("contentSummary", param);

// "内容资产" 部分：图片/视频资产累计数量。
// 注：早期版本同时返回了健康指标，现已拆分到 systemHealth 接口；
// 该接口继续保留，前端只取图片/视频字段。
// 后端按 dashboardV2ContentSummary 权限网关。
const dashboardContentAssets = (param: DashboardV2Request) =>
  postDashboardV2("contentAssets", param);

// "系统健康" 部分：AI 调用的成功率、平均耗时、成功/失败/总调用数。
// 从原 contentAssets 拆出的独立接口。
// 响应：{ callCount, successCount, failCount, successRate(string %), avgLatencyMs }
const dashboardSystemHealth = (param: DashboardV2Request) =>
  postDashboardV2("systemHealth", param);

// C1：调用次数趋势
const dashboardCallTrend = (param: DashboardV2Request) =>
  postDashboardV2("callTrend", param);

// C2：积分消耗趋势
const dashboardScoreTrend = (param: DashboardV2Request) =>
  postDashboardV2("scoreTrend", param);

// C3：Token 消耗趋势
const dashboardTokenTrend = (param: DashboardV2Request) =>
  postDashboardV2("tokenTrend", param);

// C4：活跃成员趋势
const dashboardActiveMemberTrend = (param: DashboardV2Request) =>
  postDashboardV2("activeMemberTrend", param);

// C5：内容创作趋势（4 条线）
const dashboardContentTrend = (param: DashboardV2Request) =>
  postDashboardV2("contentTrend", param);

// R1：成员排行 TOP N
const dashboardMemberRanking = (param: DashboardV2Request) =>
  postDashboardV2("memberRanking", param);

// D1：模型分布
const dashboardModelDistribution = (param: DashboardV2Request) =>
  postDashboardV2("modelDistribution", param);

// D2：供应商分布
const dashboardSupplierDistribution = (param: DashboardV2Request) =>
  postDashboardV2("supplierDistribution", param);

// D3：内容创作分布（环形图）
const dashboardContentDistribution = (param: DashboardV2Request) =>
  postDashboardV2("contentDistribution", param);

// D4：应用分布 TOP N
const dashboardAppDistribution = (param: DashboardV2Request) =>
  postDashboardV2("appDistribution", param);

// D5：客户端渠道分布
const dashboardChannelDistribution = (param: DashboardV2Request) =>
  postDashboardV2("channelDistribution", param);

// R2：按部门拆分（企业版独有）
const dashboardDepartmentBreakdown = (param: DashboardV2Request) =>
  postDashboardV2("departmentBreakdown", param);

/* ⑤：实时动态事件流（数据源：Redis ZSet，毫秒响应；
 * 与其他 V2 接口共用前缀，但请求体形态不同：只接受
 * sinceTs/limit/categories/successOnly，不带 startDate/endDate 等。 */
export interface RealtimeFeedRequest {
  /** 上次拉到的最新 ts；下次轮询用它做下限。首次不传 = 拉最近 N 条 */
  sinceTs?: number | null;
  /** 返回上限，默认 30，最大 100 */
  limit?: number;
  /** 仅返回某些大类的事件 */
  categories?: ("TEXT" | "IMAGE" | "VIDEO" | "VOICE")[];
  /** true = 仅成功；false/省略 = 包含失败 */
  successOnly?: boolean;
}

const dashboardRealtimeFeed = (param: RealtimeFeedRequest = {}) =>
  service({
    method: "post",
    url: `${DASHBOARD_V2_BASE}/realtimeFeed`,
    data: JSON.stringify(param),
    headers: { "Content-Type": "application/json" },
  });

/* ============================================================
 * 数据看板布局持久化（per-user）
 * 路由：/api/chat/web/dashboard/v2/layout (GET / POST)
 * 详见仓库根目录 dashboard-layout-api.md
 * 后端就位前，前端走 BigScreen/layoutService.ts 的本地存储。
 * ============================================================ */
export interface DashboardLayoutPayload {
  // ===== Data center page (normal, non-fullscreen) =====

  /** Data-center KPI order (key list); unknown KPIs auto-append at end */
  normalKpiLayout?: string[];
  /** Data-center KPI keys explicitly hidden by the user */
  normalKpiHidden?: string[];

  /** Data-center chart order (existing field, behaviour unchanged) */
  normalLayout?: string[];
  /** Data-center chart keys explicitly hidden by the user */
  normalChartHidden?: string[];

  // ===== Big-screen page (fullscreen) =====

  /** Fullscreen KPI order (independent from normalKpiLayout) */
  fsKpiLayout?: string[];
  /** Fullscreen KPI keys explicitly hidden by the user */
  fsKpiHidden?: string[];

  /** Fullscreen chart order; absence from this array implies hidden */
  fsLayout?: string[];
  /** Fullscreen column count: 2 / 3 / 4 */
  fsColumns?: 2 | 3 | 4;
}

const getDashboardLayout = () =>
  service({
    method: "get",
    url: `${DASHBOARD_V2_BASE}/layout`,
    headers: { "Content-Type": "application/json" },
  });

const saveDashboardLayout = (param: DashboardLayoutPayload) =>
  service({
    method: "post",
    url: `${DASHBOARD_V2_BASE}/layout`,
    data: JSON.stringify(param ?? {}),
    headers: { "Content-Type": "application/json" },
  });

// 应用升级
const upgradeApp = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/app/upgrade",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// 私聊配置保存
const privateSetting = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/hosting/config/private/save",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// 群聊配置保存
const groupSetting = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/hosting/config/group/save",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 单个群聊配置删除
const delectGroupSetting = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/hosting/config/group/delete",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 聊天设置详情查询
const getGroupSetting = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/web/hosting/config/detail",
    params: param,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// 团队空间-公司信息编辑
const editCompanyInfo = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/company/update",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// 团队空间-移出成员
const deleteCompanyMember = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/company/deleteCompanyMember",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 团队空间-资产迁移（把迁移成员名下的企业资源转移给继承成员）
const inheritCompanyMemberData = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/company/inheritCompanyMemberData",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 团队空间-退出团队空间
const exitCompany = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/chat/web/company/exitCompany",
    params: param,
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 获取用户未命中知识库调用记录

const getNotKnowBase = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/getNotHitKnowledgeInvokeRecord",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 对话活跃度统计
const getRecordActiveCount = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/data/board/recordActiveCount",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 词云
const getHighFrequencyWord = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/data/board/get/highFrequencyWord",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 词云详情
const getHighFrequencyWordDetail = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/get/highFrequencyWordRecord",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 获取转人工的调用记录
const getRecordInvokeRecord = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/getTransferManualInvokeRecord",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const getHistoryLogin = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/web/hosting/login/last_info",
    params: param,
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 注销群聊接口
const groupCancel = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/hosting/group/cancel",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// 插件分类
const getGroupType = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/chat/web/plugin/group/list",
    params: param,
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 插件详情
const getGroupDetail = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/chat/web/plugin/detail",
    params: param,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// 客户列表

const getCustomerList = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/chat/web/customer/list",
    params: param,
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 标签列表
const getAllCustomerTagList = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/chat/web/customer/tag/all",
  });
};
// 获取单个用户标签
const getCustomerTagList = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/chat/web/customer/tag/self",
    params: param,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const getTagList = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/chat/web/customer/tag/list",
    params: param,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// 添加标签
const addTagList = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/customer/tag/add",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 删除标签
const deleteTagList = async (param: any) => {
  return await service({
    method: "post",
    url: `/api/chat/web/customer/tag/delete/${param.tagId}`,
  });
};
// 修改标签
const updateTagList = async (param: any) => {
  return await service({
    method: "post",
    url: `/api/chat/web/customer/tag/update/${param.tagId}`,
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// 批量打标签
const batchTag = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/customer/tag/mapping/batch",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// Ai批量打标签
const batchAiTag = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/customer/tag/mapping/ai",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 刷新token
const getUserDetail = async () => {
  return await service({
    method: "get",
    url: "/api/chat/web/app/user/get/detail",
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// ─── 积分任务 ───
// 返回按分栏聚合的成长任务列表：
// -> { categories: [{ code, name, sort, tasks: [{ code, title, desc, sort,
//      rewardScore, rewardValidDays, done, repeatable }] }],
//      pendingScore, completedCount, totalCount }
const getGrowthTaskState = async () => {
  return await service({
    method: "get",
    url: "/api/chat/web/app/user/growth/task/list",
  });
};
//成员设置角色
const setCompanyMemberRole = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/company/setCompanyMemberRole",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
//新增角色
const addCompanyRole = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/company/addCompanyRole",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 复制角色（含角色的全部权限）
const copyCompanyRole = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/company/copyCompanyRole",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// 编辑角色
const modifyCompanyRole = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/company/modifyCompanyRole",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// 查询角色的功能权限资源
const queryCompanyRoleFunctionResource = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/chat/web/company/queryCompanyRoleFunctionResource",
    params: param,
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 修改角色功能权限资源
const modifyCompanyRoleFunctionResource = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/company/modifyCompanyRoleFunctionResource",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
//查询角色数据权限资源
const queryCompanyRoleDataResource = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/chat/web/company/queryCompanyRoleDataResource",
    params: param,
    headers: {
      "Content-Type": "application/json",
    },
  });
};
//查询角色数据权限资源
const modifyCompanyRoleDataResource = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/company/modifyCompanyRoleDataResource",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// 删除角色
const deleteCompanyRole = async (param: any) => {
  return await service({
    url: "/api/chat/web/company/deleteCompanyRole",
    method: "delete",
    data: param,
  });
};
// 获取标签分组
const getCustomerTagGroup = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/chat/web/customer/tag/group/list",
    params: param,
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 获取所有标签分组
const getAllCustomerTagGroup = async () => {
  return await service({
    method: "get",
    url: "/api/chat/web/customer/tag/group/all",
  });
};

// 创建标签分组
const createTagGroup = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/customer/tag/group/add",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// 删除标签分组
const deleteTagGroupList = async (param: any) => {
  return await service({
    method: "post",
    url: `/api/chat/web/customer/tag/group/delete/${param.tagGroupId}`,
  });
};
// 修改标签分组
const updateTagGroupList = async (param: any) => {
  return await service({
    method: "post",
    url: `/api/chat/web/customer/tag/group/update/${param.tagGroupId}`,
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// 同步客户
const syncCustomer = async () => {
  return await service({
    method: "post",
    url: "/api/chat/web/customer/sync",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// 工作流发布到广场
const workflowPublish = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/workflow/publish",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 工作流详情查询

const getChatWorkFlowDetail = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/web/workflow/square/detail",
    params: param,
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// const runWebWorkFlow = async (param: any) => {
//   return await service({
//     method: "get",
//     url: "/api/web/workflow/square/detail",
//     params: param,
//     headers: {
//       "Content-Type": "application/json",
//     },
//   });
// 取消工作流发布

const cancelWorkFlow = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/workflow/publish/cancel",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 分配积分
const postAllocatepPoints = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/company/companyBalanceManage",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const getAlllocatepPoints = async () => {
  return await service({
    method: "get",
    url: "/api/chat/web/company/sumCompanyBalance",
  });
};
const getAllBenefits = async () => {
  return await service({
    method: "get",
    url: "/api/chat/web/benefits/getTotalBenefitsScore",
  });
};
const getBenefitsSummary = async () => {
  return await service({
    method: "get",
    url: "/api/chat/web/benefits/summary",
  });
};
const parseFeishu = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/knowledge/base/feishu/parse",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const importFileFeishu = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/knowledge/base/file/embedding",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const saveFeishuChnneld = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/knowledge/feishu/authorization/save",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const getFeishuChnneld = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/web/knowledge/feishu/authorization/info",
  });
};

const repeatMediaName = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/media/change_name",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 数据库
const getAllDataBase = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/web/database/list",
    params: param,
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 创建数据库
const createDatabase = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/database/create",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 查询表
const queryDatabaseTable = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/web/database/tables",
    params: param,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

//查询表字段
const queryDatabaseTableschema = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/web/database/table_schema",
    params: param,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// 修改数据表
const editDatbaseTableschema = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/database/builtin/edit_data",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
//

const queryOnlineDatabase = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/web/database/online/tables",
    params: param,
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const queryDataTable = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/database/data",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const saveOnlineDataTable = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/database/online/table/save",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const saveBuiltinFormDataTable = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/database/builtin/create_table",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const saveDatabaseFormDataTable = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/database/system/create_table",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const getDatabaseDetail = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/web/database",
    params: param,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const editTableDes = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/database/table/update_comment",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const importTableData = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/database/builtin/import_data",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const templateTableData = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/web/database/builtin/template_file",
    // params: param,
    // headers: {
    //   "Content-Type": "application/json",
    // },
    responseType: "blob",
    params: param,
  });
};
const deleteTableData = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/database/builtin/delete_data",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const addTableColumn = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/database/table/add_field",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const deleteTableColumn = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/database/table/delete_field",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const addTableData = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/database/builtin/add_data",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const editTableData = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/database/builtin/edit_data",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const editDataBaseDetail = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/database/update",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const appBindDatabase = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/database/relation/add",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const deleteData = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/database/delete",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const deleteDataTable = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/database/table/delete",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const parseDataTable = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/database/table/pre_parse",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const importParseDataTable = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/database/builtin/fast_import_data",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const editDataTableComment = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/database/table/update_field_comment",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 插件解析
const parseDebug = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/plugin/debug",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const exportTableComment = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/web/database/table/export",
    responseType: "blob",
    params: param,
  });
};

const voiceAppWorkflow = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/voice/read",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
    responseType: "blob",
  });
};

const queryTemplateList = async (param: any) => {
  return await service({
    url: "/api/chat/web/role/template/list",
    method: "get",
    params: param,
    // headers: {
    //   "Content-Type": "application/json",
    // },
    // data: JSON.stringify(param),
  });
};
const templateGroupList = async () => {
  return await service({
    method: "get",
    url: "/api/chat/web/role/template/group/list",
  });
};
const templateDetail = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/chat/web/app/template/detail",
    params: param,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const copyTemplateApp = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/app/template/copy",
    params: param,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const workflowSystem = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/web/workflow/system/args",
  });
};

const copyApp = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/app/app/copy",
    params: param,
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const copyFlowWorkApi = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/app/workflow/copy",
    params: param,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const exportChatList = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/control/msg/session/history/export",
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
    },
    data: param,
  });
};
const exportMediaResourceList = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/chat/web/media/export",
    params: param,
    responseType: "blob",
  });
};

const deleteMediaResourceList = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/media/delete/list",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};

const supplierTypeList = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/model/supplier/type/list",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};

const modelManageList = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/maas/models",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};

// OEM 站点的模型功能开关（免登录，按访问域名查）。OEM 租户默认只有内置模型，
// 后端白名单内的域名仍可使用自定义模型。
const oemModelFeatures = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/web/maas/oem/features",
    params: param,
  });
};

// Playground: fetch a single model detail with its `params` schema
const modelPlaygroundDetail = async (code: string) => {
  return await service({
    method: "get",
    url: "/api/web/maas/models/detail",
    params: { code },
  });
};

// Playground: clear the backend Redis chat memory bound to a session_id.
// Frontend localStorage chat history is independent and not affected.
const modelPlaygroundClear = async (sessionId: string) => {
  return await service({
    method: "post",
    url: "/api/web/models/text/clear",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify({ session_id: sessionId }),
  });
};

// Image / video generation can take well over a minute on the model side,
// so we override the default 60s axios timeout to 10 minutes for these
// playground media endpoints.
const PLAYGROUND_MEDIA_TIMEOUT_MS = 10 * 60 * 1000;

// Playground: synchronous image generation (returns one or more image URLs).
// Body shape is per-model and follows the param schema returned by
// modelPlaygroundDetail (e.g. `model`, `prompt`, `size`, `aspect_ratio`,
// `image_url` for img2img, etc.).
const modelPlaygroundImageGenerate = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/models/image/generations",
    headers: { "Content-Type": "application/json" },
    timeout: PLAYGROUND_MEDIA_TIMEOUT_MS,
    data: JSON.stringify(param),
  });
};

// Playground: create an asynchronous video generation task. Response carries
// a `task_id` which the caller must poll via modelPlaygroundVideoTask().
const modelPlaygroundVideoGenerate = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/models/video/generations",
    headers: { "Content-Type": "application/json" },
    timeout: PLAYGROUND_MEDIA_TIMEOUT_MS,
    data: JSON.stringify(param),
  });
};

// Playground: poll the status of a previously created video task.
// Returns `status` ∈ {PENDING, RUNNING, SUCCESS, FAILED} and (on SUCCESS)
// `video_url`.
const modelPlaygroundVideoTask = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/models/video/tasks",
    headers: { "Content-Type": "application/json" },
    timeout: PLAYGROUND_MEDIA_TIMEOUT_MS,
    data: JSON.stringify(param),
  });
};

// Playground: synthesize speech. Returns a hosted `url` rather than a byte
// stream, so a conversation restored from localStorage keeps playing.
const modelPlaygroundAudioSpeech = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/models/audio/speech",
    headers: { "Content-Type": "application/json" },
    timeout: PLAYGROUND_MEDIA_TIMEOUT_MS,
    data: JSON.stringify(param),
  });
};

// Playground: transcribe an already-uploaded audio file. Takes the OSS url
// produced by the shared attachment upload, and returns `text`.
const modelPlaygroundAudioTranscribe = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/models/audio/transcriptions",
    headers: { "Content-Type": "application/json" },
    timeout: PLAYGROUND_MEDIA_TIMEOUT_MS,
    data: JSON.stringify(param),
  });
};

// Playground: train a cloned voice from an already-uploaded sample. Returns the
// new voice's id, its `voice_type` (what /audio/speech takes as `voice`) and a
// `status` of training / ready / failed.
const modelPlaygroundVoiceClone = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/models/voice/clone",
    headers: { "Content-Type": "application/json" },
    // Training runs inline upstream and can take minutes on a long sample.
    timeout: PLAYGROUND_MEDIA_TIMEOUT_MS,
    data: JSON.stringify(param),
  });
};

// Playground: poll one cloned voice until it reports ready or failed.
const modelPlaygroundVoiceCloneQuery = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/models/voice/clone/query",
    headers: { "Content-Type": "application/json" },
    timeout: PLAYGROUND_MEDIA_TIMEOUT_MS,
    data: JSON.stringify(param),
  });
};

// Playground: the caller's cloned voices.
const modelPlaygroundVoiceCloneList = async () => {
  return await service({
    method: "get",
    url: "/api/web/models/voice/clone/list",
  });
};

// Playground: one page of the voices a TTS model can speak with, each with the
// avatar and audition clip the picker shows. `selected` asks for one specific
// voice_type alongside the page, so the field can render the current pick even
// when it sits on another page.
const modelPlaygroundVoiceOptions = async (param: {
  code: string;
  vendor?: string;
  keyword?: string;
  page_no?: number;
  page_size?: number;
  selected?: string;
}) => {
  return await service({
    method: "get",
    url: "/api/web/models/voice/options",
    params: param,
  });
};

// Playground: ask a judge model to answer a set of typed questions about a
// state. Plain JSON in, plain JSON out — no /chat/completions, no streaming.
// Body: { model, state: string | object, questions: { <qid>: { type,
// instructions, criteria? } } }.
const modelJudge = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/models/judge",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(param),
  });
};

// Playground: rename a cloned voice or change its avatar. Omitted fields are
// left alone; an empty avatar_url clears the picture.
const modelPlaygroundVoiceCloneUpdate = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/models/voice/clone/update",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(param),
  });
};

// The productType the 声音复刻 slot packages are filed under in ai_chat_product.
// A constant because the cash path reaches them through the generic
// getProduct / createOrder pair, which takes the type as a plain string.
const VOICE_SLOT_PRODUCT_TYPE = "VOICE_CLONE";

// The 声音复刻 entitlement packages on sale. Same shape as any other product, so
// the cash purchase reuses rechargeOrder / getRecordDetail unchanged.
const voiceSlotProductList = async () => {
  return await getProduct({ productType: VOICE_SLOT_PRODUCT_TYPE });
};

// Buy a package with 积分. The counterpart of rechargeOrder for cash: same
// product row, but 积分 are deducted in this one request, so the order comes back
// already PAID and there is no QR to show or order to poll.
//
// Both paths claim a free inventory slot on success. An empty pool is
// rejected with a message asking the caller to contact an admin.
const scoreOrder = async (param: { goodId: string }) => {
  return await service({
    method: "post",
    url: "/api/chat/web/app/user/scoreOrder",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(param),
  });
};

const modelSupplierSave = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/model/supplier/save",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const modelSupplierDetail = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/model/supplier/detail",
    headers: {
      "Content-Type": "application/json",
    },
    params: param,
  });
};

const modelManageDelete = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/model/delete",
    headers: {
      "Content-Type": "application/json",
    },
    params: param,
  });
};
const modelSupplierDelete = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/model/supplier/delete",
    headers: {
      "Content-Type": "application/json",
    },
    params: param,
  });
};

const getModelSupplierTypeAllList = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/model/supplier/type/all/list",
    headers: {
      "Content-Type": "application/json",
    },
    params: param,
  });
};

const mcpDebug = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/plugin/mcp/debug",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(param),
  });
};
const getPluginTools = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/chat/web/plugin/mcp/tools",
    params: param,
  });
};

const saveScheduler = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/knowledge/base/scheduler/save",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const getHostingGroupFriendList = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/web/hosting/group/friend/list",
    params: param,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const handleSyncPost = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/knowledge/base/sync",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const editCompanyMember = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/company/updateCompanyMember",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const createFormSet = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/plugin/form/create",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const getFormSetList = async () => {
  return await service({
    method: "post",
    url: "/api/web/plugin/form/list",
    // data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const deleteFormSet = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/plugin/form/delete",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const getFormSetDetail = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/plugin/form/detail",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const setFormSetConfig = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/plugin/form/config",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const setFormSetSubmit = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/plugin/form/submit",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const upDateFormSetSubmit = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/plugin/form/update",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const getCompanyInfo = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/get/companyInfo",
    params: param,
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const createCompanyMember = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/company/createMember",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const updateMemberPassword = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/company/updateMemberPassword",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const createAgentTeam = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/agent-team/create",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const getMultiAgentDetail = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/web/agent-team/detail",
    params: param,
  });
};

const getMultiAgentList = async () => {
  return await service({
    method: "get",
    url: "/api/web/agent-team/list",
  });
};

const updateMultiAgent = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/agent-team/update",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const deleteMultiAgent = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/agent-team/delete",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const addMultiAgentMember = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/agent-team/member/add",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const updateMultiAgentMember = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/agent-team/member/update",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const deleteMultiAgentMember = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/agent-team/member/delete",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const getDeviceList = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/channel/device/list",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const postFeedBack = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/feedback",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const createSuperAgent = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/superagent/create",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
const getMyRuntimeList = async (withStatus = false) => {
  return await service({
    method: "get",
    url: "/api/chat/web/superagent/runtime/list",
    params: { withStatus },
  });
}
const renameRuntime = async (param: { runtimeId: string; name: string }) => {
  return await service({
    method: "post",
    url: "/api/chat/web/superagent/runtime/rename",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
// ---- multi-agent conversations (single / group chat) ----
const listAgentConversations = async (param?: {
  page?: number;
  pageSize?: number;
  type?: string;
  keyword?: string;
}) => {
  return await service({
    method: "get",
    url: "/api/chat/web/superagent/conversation/list",
    params: param,
  });
}
const conversationPost = (path: string) => async (param: Record<string, any>) => {
  return await service({
    method: "post",
    url: `/api/chat/web/superagent/conversation/${path}`,
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
const createAgentConversation = conversationPost("create");
/** Existing one-to-one conversation with an agent / app, created on first use. */
const openAgentConversation = conversationPost("open");
const updateAgentConversation = conversationPost("update");
const deleteAgentConversation = conversationPost("delete");
const touchAgentConversation = conversationPost("touch");
// Abort a workflow run in flight (trace_id comes from the node events of the stream).
const cancelWorkflowRun = async (param: { trace_id: string; app_code: string }) => {
  return await service({
    method: "post",
    url: "/api/web/workflow/cancel",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
// Stored turns of an app conversation; page 1 = latest messages.
const getConversationHistory = async (param: { conversationId: string; page: number; pageSize: number }) => {
  return await service({
    method: "get",
    url: "/api/chat/web/superagent/conversation/history",
    params: param,
  });
}
const getSuperAgentQuota = async () => {
  return await service({
    method: "get",
    url: "/api/chat/web/superagent/quota",
  });
}
const getSuperAgentDetail = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/chat/web/superagent",
    params: param,
  });
}
const getSuperAgentConfigDetail = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/control/superagent/config/detail",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
const updateSuperAgent = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/chat/web/superagent/update",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
const updateSuperAgentDetail = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/control/superagent/config/save",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
const getAgentSkillList = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/control/skill/list",
    params: param,
  });
}
const createAgentSkillList = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/control/skill/add",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
const enableAgentSkill = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/control/skill/open",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
const disableAgentSkill = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/control/skill/close",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
const deleteAgentSkill = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/control/skill/delete",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
const getMemoryList = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/control/memory/list",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
const getMemoryDetail = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/control/memory/content",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
const getKnowledgePageList = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/control/knowledge/list",
    params: param,
  });
}
const getKnowledgePageContent = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/control/knowledge/read",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
const getKnowledgeGraph = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/control/knowledge/graph",
    params: param,
  });
}
// ─── Agent workspace (空间) ───
// Reserved endpoints, not implemented on the server yet. The UI degrades to a
// placeholder while they are unavailable.
// { clientId, path?, showHidden? } -> { path, root, entries[], truncated }
const getWorkspaceTree = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/control/workspace/tree",
    params: param,
  });
}
// { clientId, q, limit? } -> { query, results[] }
const searchWorkspaceFiles = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/control/workspace/search",
    params: param,
  });
}
// { clientId, path } -> { file } , resolves both relative and absolute paths
const resolveWorkspaceFile = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/control/workspace/resolve",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
// { clientId } -> { root, exists }
const getWorkspaceMeta = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/control/workspace/meta",
    params: param,
  });
}
// { clientId, path } -> { content, truncated } , for text-like files only
const readWorkspaceFile = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/control/workspace/read",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
// Binary passthrough used for image / video / audio / pdf / html previews
const downloadWorkspaceFile = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/control/workspace/file",
    params: param,
    responseType: "blob",
  });
}
const getSuperAgentChannelList = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/control/superagent/channels/list",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
const createSuperAgentChannel = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/control/superagent/channels/create",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
const updateSuperAgentChannel = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/control/superagent/channels/update",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
const deleteSuperAgentChannel = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/control/superagent/channels/delete",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
const startFeishuScan = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/control/superagent/channels/feishu/scan/start",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
const getFeishuScanStatus = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/control/superagent/channels/feishu/scan/status",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}

const getSuperAgentStatus = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/chat/web/superagent/status",
    params: param,
  });
};
/** Online flags for many agents at once; `codes` is comma-separated. */
const getSuperAgentStatusBatch = async (param: { codes: string }) => {
  return await service({
    method: "get",
    url: "/api/chat/web/superagent/status/batch",
    params: param,
  });
};
// Desktop client release metadata. Served from the current origin, so OEM
// deployments resolve their own domain and keep downloads self-contained.
const getClientDownloadInfo = async (params?: { domain?: string; product?: string }) => {
  return await service({
    method: "get",
    url: "/api/client/download/info",
    params,
  });
};
const createSuperAgentDes = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/agent/desc/autoCreate",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const createSuperAgentHeaderimage = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/web/agent/avatar/autoCreate",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const getAppRoleBatchQuery = async (param: any) => {
  return await service({
    method: "POST",
    url: "/api/chat/web/app/batch/query",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const createSuperAgentSession = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/control/superagent/session/new",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}

const getSuperAgentSession = async (param: any) => {
  return await service({
    method: "get",
    url: "/api/control/superagent/session/get",
    params: param,
  });
}
const getSuperAgentHistoryList = async (param: any) => {
  return await service({
    method: "post",
    url: "/api/control/chat/history",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}

const getSkillHubList = async (param?: { page?: number; limit?: number; category?: string; provider?: string; tag?: string; q?: string }) => {
  return await service({
    method: "get",
    url: "/api/control/skill-hub/list",
    params: param,
  });
}

// ---- skill market (agent platform skills + content-creation skills) ----
const getSkillMarketList = async (param?: { source?: string; keyword?: string; category?: string }) => {
  return await service({
    method: "get",
    url: "/api/chat/web/skill/market/list",
    params: param,
  });
}
const getSkillMarketDetail = async (param: { ref: string }) => {
  return await service({
    method: "get",
    url: "/api/chat/web/skill/market/detail",
    params: param,
  });
}
// draft: managers read the skill's draft (falls back to the current version when there is none)
const getSkillMarketFiles = async (param: { ref: string; draft?: boolean }) => {
  return await service({
    method: "get",
    url: "/api/chat/web/skill/market/files",
    params: param,
  });
}
const getSkillMarketFile = async (param: { ref: string; path: string; draft?: boolean }) => {
  return await service({
    method: "get",
    url: "/api/chat/web/skill/market/file",
    params: param,
  });
}
// Saves the edited files into the skill's draft; a change with deleted: true removes the file,
// encoding: 'base64' marks uploaded binary content. Resolves to the draft, or null when the result
// matches the current version.
const saveSkillMarketFiles = async (param: {
  skillId: number;
  baseVersion?: string;
  files: { path: string; content?: string; encoding?: 'base64'; deleted?: boolean }[];
}) => {
  return await service({
    method: "post",
    url: "/api/chat/web/skill/market/files/save",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
    timeout: 120000,
  });
}
// FormData fields: skillId, baseVersion?, and file (SKILL.md / zip) or files[] + paths (JSON array).
// A folder or zip replaces every file of the draft, a lone SKILL.md only that file.
const replaceSkillMarketDraft = async (data: FormData) => {
  return await service({
    method: "post",
    url: "/api/chat/web/skill/market/draft/replace",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 120000,
  });
}
const publishSkillMarketDraft = async (param: { skillId: number; version?: string; changelog?: string }) => {
  return await service({
    method: "post",
    url: "/api/chat/web/skill/market/draft/publish",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
    timeout: 120000,
  });
}
const discardSkillMarketDraft = async (param: { id: number }) => {
  return await service({
    method: "post",
    url: "/api/chat/web/skill/market/draft/discard",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
// Whether a new skill with this visibility can use this install name; public skills share one slug space,
// enterprise and personal ones another. sameName is the user's own skill already holding it in that space
const previewSkillMarketSlug = async (params: { slug: string; visibility?: string }) => {
  return await service({
    method: "get",
    url: "/api/chat/web/skill/market/slug/preview",
    params,
  });
}
// FormData fields: file (SKILL.md / zip), files[] + paths (JSON array, folder upload) or url (GitHub link),
// skillId?, name?, description?, iconUrl?, category?, visibility?, version?, changelog?
const uploadSkillMarketSkill = async (data: FormData) => {
  return await service({
    method: "post",
    url: "/api/chat/web/skill/market/upload",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 120000,
  });
}
// Checks a picked package against the Agent Skills spec without storing it; same file parts as upload
const checkSkillMarketPackage = async (data: FormData) => {
  return await service({
    method: "post",
    url: "/api/chat/web/skill/market/upload/check",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 120000,
  });
}
// Downloads the skill a GitHub link points to, for a preview before creating it
const resolveSkillMarketLink = async (param: { url: string }) => {
  return await service({
    method: "post",
    url: "/api/chat/web/skill/market/link/resolve",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
    timeout: 120000,
  });
}
/** SKILL.md the platform generates for one of its resources: plugin / knowledge / app / workflow / database */
const previewResourceSkill = async (param: { type: string; code: string }) => {
  return await service({
    method: "get",
    url: `/api/web/skills/${encodeURIComponent(param.type)}/${encodeURIComponent(param.code)}/preview`,
  });
}
const updateSkillMarketSkill = async (param: { id: number; name?: string; description?: string; introduction?: string; iconUrl?: string; categories?: string[]; visibility?: string }) => {
  return await service({
    method: "post",
    url: "/api/chat/web/skill/market/update",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
const deleteSkillMarketSkill = async (param: { id: number }) => {
  return await service({
    method: "post",
    url: "/api/chat/web/skill/market/delete",
    data: JSON.stringify(param),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
// Display metadata for installed skill names (comma separated): names for market / content installs,
// privateNames for private ones
const resolveSkillMarketMeta = async (param: { names?: string; privateNames?: string }) => {
  return await service({
    method: "get",
    url: "/api/chat/web/skill/market/resolve",
    params: param,
  });
}

const getSessionListControl = async (param: { clientId: string; agentId?: string; channelType?: string; page?: number; pageSize?: number }) => {
  return await service({
    method: "get",
    url: "/api/control/session/list",
    params: param,
  });
};

const deleteSessionControl = async (param: { clientId: string; agentId?: string; sessionId: string }) => {
  return await service({
    method: "post",
    url: "/api/control/session/delete",
    data: JSON.stringify(param),
    headers: { "Content-Type": "application/json" },
  });
};

const renameSessionControl = async (param: { clientId: string; agentId?: string; sessionId: string; title: string }) => {
  return await service({
    method: "post",
    url: "/api/control/session/rename",
    data: JSON.stringify(param),
    headers: { "Content-Type": "application/json" },
  });
};

const clearSessionContext = async (param: { clientId: string; agentId?: string; sessionId: string }) => {
  return await service({
    method: "post",
    url: "/api/control/session/clear_context",
    data: JSON.stringify(param),
    headers: { "Content-Type": "application/json" },
  });
};

const generateSessionTitle = async (param: { clientId: string; agentId?: string; sessionId: string; userMessage: string; assistantReply?: string }) => {
  return await service({
    method: "post",
    url: "/api/control/session/generate_title",
    data: JSON.stringify(param),
    headers: { "Content-Type": "application/json" },
  });
};

const getSessionHistory = async (param: { clientId: string; agentId?: string; sessionId: string; page?: number; pageSize?: number }) => {
  return await service({
    method: "get",
    url: "/api/control/session/history",
    params: param,
  });
};

// CLI device-flow authorization page: query the requested scopes by device_code
const cliAuthDeviceInfo = async (param: { device_code: string }) => {
  return await service({
    method: "get",
    url: "/api/cli/auth/device-info",
    params: param,
  });
};

// CLI device-flow authorization page: submit the user-granted scopes
const cliAuthAuthorize = async (param: {
  device_code: string;
  granted_scope?: string;
}) => {
  return await service({
    method: "post",
    url: "/api/cli/auth/authorize",
    data: param,
    headers: { "Content-Type": "application/json" },
  });
};

// 随访运营看板（医院定制，仅已配置的企业租户可见）
export function apiFollowupDashboardVisible() {
  return service({
    method: "get",
    url: "/api/web/followup/dashboard/visible",
    headers: { "Content-Type": "application/json" },
  });
}
export function apiFollowupDashboard(params?: { startDate?: string; endDate?: string }) {
  return service({
    method: "get",
    url: "/api/web/followup/dashboard",
    params,
    headers: { "Content-Type": "application/json" },
  });
}
// 内置库快指标（患者/问卷/话术），秒级返回
export function apiFollowupDashboardBase(params?: { startDate?: string; endDate?: string }) {
  return service({
    method: "get",
    url: "/api/web/followup/dashboard/base",
    params,
    headers: { "Content-Type": "application/json" },
  });
}
// 患者提问闭环（ai_channel_msg，较慢，后加载）
export function apiFollowupDashboardClosedLoop(params?: { startDate?: string; endDate?: string }) {
  return service({
    method: "get",
    url: "/api/web/followup/dashboard/closed-loop",
    params,
    headers: { "Content-Type": "application/json" },
  });
}
// 患者提问高频词（词云，基于 ai_channel_msg 患者文本分词）
export function apiFollowupHighFrequencyWord(params?: { startDate?: string; endDate?: string; number?: number }) {
  return service({
    method: "get",
    url: "/api/web/followup/dashboard/high-frequency-word",
    params,
    headers: { "Content-Type": "application/json" },
  });
}

export {
  cliAuthDeviceInfo,
  cliAuthAuthorize,
  roleAdd,
  myRole,
  getGrowthTaskState,
  roleDetail,
  apiKey,
  apiKeyList,
  changeRoleSwitch,
  userUpdate,
  getProduct,
  rechargeOrder,
  getBalance,
  getUserOrder,
  userEditUpdate,
  getRecordDetail,
  getInvokeRecord,
  roleHeighDetail,
  deleteFile,
  batchDeleteFile,
  addFile,
  deleteRole,
  applyTokenByCode,
  uploadLinkFile,
  uploadImage,
  deleteContext,
  deleteAppKey,
  queryfileList,
  editfileList,
  addFileList,
  deleteFileList,
  paintMsg,
  getImg,
  imgDetail,
  getModel,
  passwordLogin,
  getVerificationCode,
  registerAccount,
  updatePassword,
  signDay,
  weChatPay,
  bindPubilcPhone,
  queryBase,
  benefitsList,
  benefitsAccount,
  invitationCode,
  getBaseList,
  createBaseApi,
  getKnowledgeFolderTree,
  getKnowledgeFolderChildren,
  createKnowledgeFolder,
  updateKnowledgeFolder,
  moveKnowledgeFolder,
  sortKnowledgeFolder,
  deleteKnowledgeFolder,
  batchMoveKnowledgeFolder,
  batchDeleteKnowledgeFolder,
  moveKnowledgeBase,
  batchDeleteBase,
  parseBase,
  baseList,
  embeddingExport,
  baseSearch,
  cashOut,
  bindBase,
  deleteBaseApi,
  getAllModel,
  baseDetial,
  updataBase,
  baseDetele,
  roleThumb,
  roleCollection,
  allPluginsList,
  pluginsList,
  addPlugins,
  deletePulgins,
  pluginSwitch,
  queryUserKey,
  createUserKey,
  editUserKey,
  deleteUserKey,
  sendRhyPostInfo,
  sendRhygetInfo,
  forgetPwd,
  autoCreate,
  autoCreateImg,
  getPresetAvatars,
  createFile,
  exportFiles,
  getInvokeRecordEnum,
  reName,
  getScoreAll,
  getAgentRunTrace,
  addCusPlugin,
  deletePlugin,
  editCusPlugin,
  apiGetChannelList,
  apiGetSessionList,
  apiGetHistoryList,
  apiMessagePush,
  apiMessageRead,
  getMetaData,
  getWebAppList,
  createWebapp,
  getWebAppDetail,
  updateWebapp,
  deleteWebapp,
  apiGetCompanyInviteUrl,
  getUserPrivilege,
  getCompanyMember,
  getDepartmentTree,
  addDepartment,
  updateDepartment,
  moveDepartment,
  deleteDepartment,
  assignMemberDepartment,
  batchAssignMemberDepartment,
  removeMemberDepartment,
  getMemberPrivige,
  getRolePrivige,
  geCompanyIvite,
  agreeEnterCompany,
  getUseMemberPrivige,
  getUseMemberPrivilegeCost,
  addCompany,
  getCompanyDetail,
  editClient,
  deleteClientApi,
  updataQrUrl,
  getMediaList,
  deleteMedia,
  configDetail,
  configSave,
  getAccountList,
  getGroupList,
  onHostingPost,
  offHostingPost,
  onHostingGroupPost,
  offHostingGroupPost,
  updateAccountAppCode,
  updateGroupAppCode,
  synWaitOpen,
  addAppLimitConfig,
  deleteAppLimitConfig,
  queryAppLimitConfig,
  updateAppLimitConfig,
  getAdvancedConfigQuerg,
  getCompanyNotifyMember,
  saveAdvancedConfig,
  changeUserService,
  getSessionList,
  exportFileInvokeRecord,
  getHostingArea,
  getLoginQrcode,
  getHostingStatus,
  getHostingOffline,
  offlineHostingAccount,
  clientConfig,
  getWorkFlowDetail,
  saveWorkFlowDetail,
  createWorkFlowDetail,
  workflowRun,
  worFlowList,
  deleteWorkFlowDetail,
  getCronGenerate,
  runCronGenerate,
  getFriendList,
  editFlowDetail,
  getTimeRun,
  addTimeRun,
  editTimeRun,
  deleteTimeRun,
  saveTimeRun,
  getByScene,
  addByScene,
  updateByScene,
  hitSwitchByScene,
  getNoticeList,
  postReadNotice,
  postReadNoticeAll,
  getStatistics,
  editTableColums,
  tableViewAddColums,
  tableViewEditColums,
  submitInvite,
  getUseUserCount,
  getRecordChannelCount,
  getRecordCount,
  getRecordNotHitKnowledgeBaseCount,
  getScoreCostCount,
  getTransferManualCount,
  getFindByFileId,
  upgradeApp,
  privateSetting,
  groupSetting,
  delectGroupSetting,
  getGroupSetting,
  editCompanyInfo,
  deleteCompanyMember,
  inheritCompanyMemberData,
  exitCompany,
  getNotKnowBase,
  getRecordActiveCount,
  getRecordInvokeRecord,
  getHistoryLogin,
  groupCancel,
  getHighFrequencyWord,
  getHighFrequencyWordDetail,
  exportNotHitKnowledgeInvokeRecord,
  exportTransferManualInvokeRecord,
  exportHighFrequencyWordRecord,
  getGroupType,
  getGroupDetail,
  newParseWeb,
  getCustomerList,
  getUserDetail,
  getAllCustomerTagList,
  getCustomerTagList,
  getTagList,
  updateTagList,
  addTagList,
  deleteTagList,
  batchTag,
  setCompanyMemberRole,
  addCompanyRole,
  copyCompanyRole,
  modifyCompanyRole,
  deleteCompanyRole,
  queryCompanyRoleFunctionResource,
  modifyCompanyRoleFunctionResource,
  queryCompanyRoleDataResource,
  modifyCompanyRoleDataResource,
  getCustomerTagGroup,
  getAllCustomerTagGroup,
  createTagGroup,
  deleteTagGroupList,
  updateTagGroupList,
  syncCustomer,
  batchAiTag,
  workflowPublish,
  getChatWorkFlowDetail,
  cancelWorkFlow,
  getAccountAppDetail,
  postAllocatepPoints,
  getAlllocatepPoints,
  getAllBenefits,
  getBenefitsSummary,
  parseFeishu,
  importFileFeishu,
  saveFeishuChnneld,
  getFeishuChnneld,
  repeatMediaName,
  uploadFile,
  getAllDataBase,
  createDatabase,
  queryDatabaseTable,
  queryDatabaseTableschema,
  editDatbaseTableschema,
  queryOnlineDatabase,
  queryDataTable,
  saveOnlineDataTable,
  saveBuiltinFormDataTable,
  getDatabaseDetail,
  editTableDes,
  importTableData,
  templateTableData,
  deleteTableData,
  addTableColumn,
  addTableData,
  editTableData,
  editDataBaseDetail,
  appBindDatabase,
  deleteData,
  deleteDataTable,
  parseDataTable,
  importParseDataTable,
  editDataTableComment,
  voiceTonePage,
  getVoiceDemo,
  parseDebug,
  exportTableComment,
  voiceAppWorkflow,
  queryTemplateList,
  templateGroupList,
  templateDetail,
  copyTemplateApp,
  workflowSystem,
  copyApp,
  copyFlowWorkApi,
  deleteTableColumn,
  exportChatList,
  apiGetChannelTag,
  apiGetFriendList,
  deleteMediaResourceList,
  supplierTypeList,
  modelManageList,
  oemModelFeatures,
  modelPlaygroundDetail,
  modelPlaygroundClear,
  modelPlaygroundImageGenerate,
  modelPlaygroundVideoGenerate,
  modelPlaygroundVideoTask,
  modelPlaygroundAudioSpeech,
  modelPlaygroundAudioTranscribe,
  modelPlaygroundVoiceClone,
  modelPlaygroundVoiceCloneQuery,
  modelPlaygroundVoiceCloneList,
  modelPlaygroundVoiceOptions,
  modelPlaygroundVoiceCloneUpdate,
  modelJudge,
  VOICE_SLOT_PRODUCT_TYPE,
  voiceSlotProductList,
  scoreOrder,
  modelSupplierSave,
  modelSupplierDetail,
  modelManageDelete,
  modelSupplierDelete,
  getModelSupplierTypeAllList,
  exportMediaResourceList,
  mcpDebug,
  getPluginTools,
  saveScheduler,
  getHostingGroupFriendList,
  handleSyncPost,
  editCompanyMember,
  createFormSet,
  getFormSetList,
  deleteFormSet,
  getFormSetDetail,
  setFormSetConfig,
  setFormSetSubmit,
  getCompanyInfo,
  saveDatabaseFormDataTable,
  createCompanyMember,
  updateMemberPassword,
  getNewFriendList,
  queryRobotList,
  upDateFormSetSubmit,
  createAgentTeam,
  getMultiAgentDetail,
  getMultiAgentList,
  updateMultiAgent,
  deleteMultiAgent,
  addMultiAgentMember,
  updateMultiAgentMember,
  deleteMultiAgentMember,
  getDeviceList,
  postFeedBack,
  createSuperAgent,
  getMyRuntimeList,
  renameRuntime,
  listAgentConversations,
  createAgentConversation,
  openAgentConversation,
  updateAgentConversation,
  deleteAgentConversation,
  touchAgentConversation,
  getConversationHistory,
  cancelWorkflowRun,
  getSuperAgentQuota,
  getSuperAgentDetail,
  getSuperAgentConfigDetail,
  updateSuperAgent,
  updateSuperAgentDetail,
  getAgentSkillList,
  createAgentSkillList,
  enableAgentSkill,
  disableAgentSkill,
  deleteAgentSkill,
  getMemoryList,
  getMemoryDetail,
  getSuperAgentChannelList,
  createSuperAgentChannel,
  updateSuperAgentChannel,
  deleteSuperAgentChannel,
  startFeishuScan,
  getFeishuScanStatus,
  getSuperAgentStatus,
  getSuperAgentStatusBatch,
  getClientDownloadInfo,
  createSuperAgentDes,
  createSuperAgentHeaderimage,
  getAppRoleBatchQuery,
  createSuperAgentSession,
  getSuperAgentSession,
  getSuperAgentHistoryList,
  getSkillHubList,
  getSkillMarketList,
  getSkillMarketDetail,
  getSkillMarketFiles,
  getSkillMarketFile,
  saveSkillMarketFiles,
  replaceSkillMarketDraft,
  publishSkillMarketDraft,
  discardSkillMarketDraft,
  previewSkillMarketSlug,
  uploadSkillMarketSkill,
  checkSkillMarketPackage,
  resolveSkillMarketLink,
  previewResourceSkill,
  updateSkillMarketSkill,
  deleteSkillMarketSkill,
  resolveSkillMarketMeta,
  getKnowledgePageList,
  getKnowledgePageContent,
  getKnowledgeGraph,
  getWorkspaceTree,
  searchWorkspaceFiles,
  resolveWorkspaceFile,
  getWorkspaceMeta,
  readWorkspaceFile,
  downloadWorkspaceFile,
  getSessionListControl,
  deleteSessionControl,
  renameSessionControl,
  clearSessionContext,
  generateSessionTitle,
  getSessionHistory,
  dashboardAiUsageSummary,
  dashboardContentSummary,
  dashboardContentAssets,
  dashboardSystemHealth,
  dashboardCallTrend,
  dashboardScoreTrend,
  dashboardTokenTrend,
  dashboardActiveMemberTrend,
  dashboardContentTrend,
  dashboardMemberRanking,
  dashboardModelDistribution,
  dashboardSupplierDistribution,
  dashboardContentDistribution,
  dashboardAppDistribution,
  dashboardChannelDistribution,
  dashboardDepartmentBreakdown,
  dashboardRealtimeFeed,
  getDashboardLayout,
  saveDashboardLayout,
};
